/*
*  Gmap
*
*  This function will render a Google Map onto the selected element
*
*  @type        class
*  @date        30/03/2023
*  @since       1.0
*
*  @param       elem        (class, id etc)
*  @param       options     override settings for calling google.maps.Map
*  @return      n/a
*/
export default class Gmap {

    constructor (elem, options = {}){

        if (!elem) {
            throw new Error('No element passed to constructor');
        }
        this.elem = elem;

        const defaultOptions = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [],
            iconBase: `https://${ window.location.hostname }/app/themes/lincoln-arts/assets/dist/images/`
        };
        this.options = Object.assign(defaultOptions, options);

        this.map = []; 
        this.markers = [];

    }

    async setup() {

        if( !document.querySelector(this.elem) ){
            return;
        }

        // create map
        this.map = this.createMap( this.elem );

        // create bounds
        this.bounds = new google.maps.LatLngBounds();

        this.markers = await this.addMarkers();

        this.centerMap();

        google.maps.event.trigger(this.map, 'resize')

    }

    createMap( elem ) {
        
        // add styles
        this.options.styles = this.styles();

        const mapElem = document.querySelector(elem).querySelector('.map');
        if (!mapElem) {
            throw new Error('Needs a .map item inside for the map');
        }

        // return map
        return new google.maps.Map( mapElem, this.options );

    }

    centerMap() {

        for (const marker of this.markers ) {
            const latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            this.bounds.extend( latlng );
        };

        if( this.markers.length == 1 ){
            this.map.setCenter( this.bounds.getCenter() );
            this.map.setZoom( this.options.zoom );
        }else{
            this.map.fitBounds( this.bounds );
        }

    }

    addMarker( markerElem ){

        if (!markerElem) {
            throw new Error('No marker passed');
        }

        const marker = new google.maps.Marker({
            position : new google.maps.LatLng(markerElem.dataset.lat, markerElem.dataset.lng),
            map	: this.map,
            icon: this.options.iconBase + 'pin.png',
        });

        if( markerElem.innerHTML ){

            const infowindow = new google.maps.InfoWindow({
                content: markerElem.innerHTML
            });
    
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( this.map, marker );
            });
        }

        return marker;

    }

    async addMarkers(){

        let markers = [];

        const allMarkers = document.querySelector(this.elem).querySelectorAll('.marker');
        
        for (const marker of allMarkers) {
            const newMarker = await this.addMarker(marker);
            markers.push( newMarker );
        };

        return markers;

    }

    styles(){
        // can change this with a JSON object if needed
        return [
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    { "color": "#FFFFFF" }
                ]
            },{
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    { "color": "#CCCCCC" }
                ]
            },{
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    { "color": "#7E7E7E" }
                ]
            },{
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    { "color": "#CCCCCC" }
                ]
            },{
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    { "color": "#7E7E7E" }
                ]
            },{
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    { "visibility": "off" }
                ]
            },{
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    { "color": "#B6B6B6" }
                ]
            },{
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    { "color": "#E3E3E3" }
                ]
            },{
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    { "color": "#3D3D3D" }
                ]
            },{
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    { "color": "#626262" }
                ]
            },{
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    { "color": "#F9F9F9" }
                ]
            },{
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    { "color": "#B6B6B6" }
                ]
            },{
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers": [
                    { "color": "#D4D4D4" }
                ]
            }
    
        ];
    }

}
